import * as url from "../../helpers/url_helper";
import { apiCall } from "./apiService";

/**
 * Updates campaign charges (variable and fixed) for a store
 * @param {string} storeDomain - Store domain
 * @param {number} campaignVariableCharge - Campaign variable charge percentage
 * @param {number} campaignFixedCharge - Campaign fixed charge in dollars
 * @param {Function} notifyError - Error notification function
 * @returns {Promise<Object|null>} Response data or null if error
 */
export const updateCampaignCharges = async (storeDomain, campaignVariableCharge, campaignFixedCharge, notifyError) => {
    return await apiCall(
        url.PUT_UPDATE_STORE,
        'PUT',
        {
            store_domain: storeDomain,
            campaign_variable_charge: Number(campaignVariableCharge),
            campaign_fixed_charge: Number(campaignFixedCharge),
        },
        notifyError,
        "Failed to update campaign charges"
    );
};

